import { useTranslation } from "react-i18next";
import Faq1 from "../../Components/FAQ/Faq1";
import PageHeader from "../../Components/layouts/PageHeader";
import Preloader from "../../Components/Preloader";
import Navbar from "../Menu/Navbar";
import Footer from "./Sections/Footer";

const FAQ = () => {
  const { t } = useTranslation();
  return (
    <>
      <Navbar type="internal" />
      <Preloader />
      <main className="main">
        <PageHeader
          current={t("menu.faq")}
          banner="assets/imgs/page-header/faq.jpg"
          link="faq"
        />
        <section className="section-box pt-50 background-body">
          <div className="container">
            <div className="row align-items-end">
              <div className="col-md-9 mb-30 wow fadeInUp">
                <h4 className="title-svg neutral-1000 mb-15 ac--font-expo ac--color-primary">
                  {t("menu.questions")}
                </h4>
                <p className="text-lg-medium text-bold neutral-500">
                  Over the years. We have questions in the field of The cars
                  care, which comes to us repeatedly from time to time.
                  Therefore, we thought that we could share with you. Perhaps
                  you have ask yourself these questions one day ....
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="box-section-term background-body pt-35 pb-85">
          <Faq1 />
        </section>
      </main>
      <Footer type="external" />
    </>
  );
};

export default FAQ;
